import React from "react";
import "../css/PrivacyPolicy.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const PrivacyPolicy = () => {
  return (
    <div>
      <Navbar />
      <div className="privacy-wrapper">
        {/* Header Section */}
        <section className="privacy-header">
          <div className="header-content">
            <div className="logo-title">
              <div className="logo-box">TS</div>
              <h3>TechSol Technologies</h3>
            </div>
            <h1><span className="text-dark">Privacy</span> Policy</h1>
            <p>Building Trust Through Transparent Data Practices</p>
          </div>

          <div className="bg-circles">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </section>

        {/* Highlights Section */}
        <section className="privacy-highlights my-2">
          <div className="highlight-card">
            <h2>256-bit</h2>
            <p>Encryption</p>
          </div>
          <div className="highlight-card">
            <h2>99.9%</h2>
            <p>Uptime & Security</p>
          </div>
          <div className="highlight-card">
            <h2>24/7</h2>
            <p>Monitoring</p>
          </div>
          <div className="highlight-card">
            <h2>GDPR</h2>
            <p>Compliant</p>
          </div>
        </section>

        {/* Main Content */}
        <section className="privacy-content">
          <h2>Our Commitment to Your Privacy</h2>
          <p>
            At TechSol Technologies, your privacy and trust are our top
            priorities. We ensure complete transparency in how we collect,
            store, and use your data.
          </p>

          <h2>Information We Collect</h2>
          <ul>
            <li>Personal details such as your name and email address</li>
            <li>Technical information like device data and IP address</li>
            <li>Communication and support interactions</li>
          </ul>

          <h2>How We Protect Your Data</h2>
          <ul>
            <li>256-bit SSL encryption</li>
            <li>Regular security audits</li>
            <li>Strict access control policies</li>
          </ul>

          <h2>Your Privacy Rights</h2>
          <p>
            You can request to view, update, or delete your personal data at any
            time. Our team ensures timely responses and data transparency.
          </p>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
